<template>
  <div>
    <div class="row mt-3 border border-3">
      <!-- !!!: sync with example from step 3 in building wizard (2021.10.20) -->
      <div class="col">
        En vertu de l’article 22, alinéa 2, de la loi du 10 juillet 1965, le nombre de voix dont
        dispose le copropriétaire majoritaire «
        {{ getPersonName({ personId: generalDetails.buildingOwnerIdArticle22 }) }} » sera réduit à
        la somme des voix des autres copropriétaires. Ainsi, «
        {{ getPersonName({ personId: generalDetails.buildingOwnerIdArticle22 }) }} » dispose de
        {{
          generalDetails.buildingOwnersWithReducedTantiemes[0].reducedMandateTantiemesChargeGenerale
        }}
        voix au lieu de
        {{
          generalDetails.buildingOwnersWithReducedTantiemes[0].totalMandateTantiemesChargeGenerale
        }}.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["generalDetails"],
};
</script>
